import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useStyles } from './style';


const AccessDenied = () => {
  const classes = useStyles();
  const naviagte = useNavigate();

  return (
    <div className={classes.root}>
      <Grid container justifyContent="center" spacing={4}>
        <Grid item lg={6} xs={12}>
          <div className={classes.content}>
            <img alt="Under development" className={classes.image} src="./images/img403.svg" />
            <Typography className={classes.title} variant="h2">
              به این صفحه دسترسی ندارید !
            </Typography>
            <Typography className={classes.subTitle} variant="subtitle2">
              پیشنهاد می‌کنیم به
              <a onClick={() => naviagte(-1)}> صفحه قبل </a>
              برگردید.

            </Typography>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default AccessDenied;
